import React from "react";

function ErrorIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="88"
      height="88"
      fill="none"
      viewBox="0 0 88 88"
    >
       <path fill="#FF1524" fillRule="evenodd" d="M44 0c24.3 0 44 19.7 44 44S68.3 88 44 88 0 68.3 0 44 19.7 0 44 0zm0 4C21.909 4 4 21.909 4 44s17.909 40 40 40 40-17.909 40-40S66.091 4 44 4zM32.686 29.858L44 41.172l11.314-11.314c.78-.781 2.047-.781 2.828 0 .781.78.781 2.047 0 2.828L46.828 44l11.314 11.314c.781.78.781 2.047 0 2.828-.78.781-2.047.781-2.828 0L44 46.828 32.686 58.142c-.78.781-2.047.781-2.828 0-.781-.78-.781-2.047 0-2.828L41.172 44 29.858 32.686c-.781-.78-.781-2.047 0-2.828.78-.781 2.047-.781 2.828 0z" />
  </svg>
  );
}

export default ErrorIcon;



   